import { farmsConfig } from 'config/constants'

export const getFarmConfig = (pid: number) => farmsConfig.find((f) => f.pid === pid)

export const getFarm = (lpSymbol: string) => farmsConfig.find((f) => f.lpSymbol === lpSymbol)
